import { Message } from 'element-ui';
import baseApi from '@/dss-common/api/base';
import utilUrl from '@/dss-common/utils/url';
import * as encryption from '@/dss-common/utils/aesEncryption';

function plain(data) {
  if (data === null || typeof data === 'undefined') {
    return data;
  }
  try {
    return JSON.parse(JSON.stringify(data));
  } catch (e) {}
}

export default {
  methods: {
    login(params) {
      const fetchParams = plain(params);
      fetchParams.password = encryption.Encrypt(fetchParams.password, fetchParams.account);
      return baseApi.loginV2(fetchParams).done((res) => {
        if (res.code === 302) {
          window.top.location.href = res.errorMessage;
          return;
        }
        if (!res.success || res.success === 'false') {
          Message({
            showClose: true,
            type: 'error',
            duration: 2000,
            message: res.errorMessage || '登录失败',
          });
          return;
        }
        const gotoUrl = utilUrl.queryString('gotoUrl', window.location.href);
        if (gotoUrl) {
          window.top.location.href = gotoUrl;
          return;
        }
        window.top.location.href = '/';
        this.$emit('ok');
      });
    },
  },
};
